export type Environment = 'LOCALHOST' | 'TEST' | 'STG' | 'PROD';

/**
 * The deployed environments (PROD/STG), as opposed to a developer machine or CI.
 *
 * Single source of truth for third-party tags that must not fire outside a real deployment —
 * analytics, tag managers and the ad/consent stacks they pull in. Gating on this keeps LOCALHOST
 * and TEST inert without coupling one vendor's gate to another's: `shouldRenderGtm` layers GTM's
 * `allowLocalhost` opt-in on top, while the GZ Tealium tag uses the bare predicate.
 */
export const isLiveEnvironment = (environment: Environment | undefined): boolean =>
  environment === 'PROD' || environment === 'STG';
